import styled from '@mui/material/styles/styled';

type PageStyleProps = React.ComponentProps<'div'> & {
  $backgroundColor?: string;
};

export const PageContainer = styled('div')<PageStyleProps>(
  ({ $backgroundColor, theme }) => ({
    display: 'grid',
    backgroundColor: $backgroundColor ?? theme.palette.background.paper,
    minHeight: ['100vh', '100svh'],
    height: '100%',
    gridTemplateRows: 'max-content auto max-content',
  }),
);

export const Content = styled('main')<PageStyleProps>({
  isolation: 'isolate',
  display: 'grid',
  overflowY: 'auto',
  justifyItems: 'center',
});
